var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScissor = function SvgScissor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6a3 3 0 0 0 1.3-.295.5.5 0 0 0 .074.07l2.96 2.37-2.91 2.035q-.068.05-.13.11A3 3 0 0 0 3 10a3 3 0 1 0 2.715 1.72L8.96 9.445l5.415 4.34a1.001 1.001 0 1 0 1.25-1.565l-4.96-3.97 4.91-3.435a1.003 1.003 0 0 0-1.15-1.64L9.04 6.95 5.71 4.285A3 3 0 1 0 3 6m0 8a1 1 0 1 1-.001-2 1 1 0 0 1 0 2M3 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  })));
};
export default SvgScissor;